// extracted by mini-css-extract-plugin
module.exports = {"contentStyles":"styles_contentStyles__3RgTq","image":"styles_image__2AnxH","title":"styles_title__3u_3Z","placeholder":"styles_placeholder__1GlEJ"};